import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { getteacherFeedback, deleteteacherFeedbacks } from '../../ReduxToolkit/Slice/Feedback/TeacherFeedback';


function TeacherFeedback() {
    const dispatch = useDispatch();
    const { status, teacherFeedbacks } = useSelector((state) => state.teacherFeedback);
    //  get
    useEffect(() => {
        if (status === "idle") {
            dispatch(getteacherFeedback())
        }
    }, [dispatch, status]);
    // delete api
    const handleDelete = (teacherFeedbackid) => {
        const Isconfirmed = window.confirm("Are you sure! you want delete this Feedback?")
        if (Isconfirmed) {
            dispatch(deleteteacherFeedbacks(teacherFeedbackid))
        };
    }
    // single data fetch
    const [email, setEmail] = useState(null);
    const [name, setName] = useState("");
    const [Designation, setDesignation] = useState("");
    const [Department, setDepartment] = useState("");
    const [question1, setQuestion1] = useState("");
    const [question2, setQuestion2] = useState("");
    const [question3, setQuestion3] = useState("");
    const [question4, setQuestion4] = useState("");
    const [question5, setQuestion5] = useState("");
    const [question6, setQuestion6] = useState("");
    const [question7, setQuestion7] = useState("");
    const [question8, setQuestion8] = useState("");
    const [question9, setQuestion9] = useState("");
    const [question10, setQuestion10] = useState("");
    const [suggestion, setSuggestion] = useState("");

    const [selectedId, setSelectedId] = useState(null);
    const handlid = (id) => {
        const selectedteacherFeedback = teacherFeedbacks.data.find(teacherFeedback => teacherFeedback._id === id);
        setEmail(selectedteacherFeedback.email);
        setName(selectedteacherFeedback.name);
        setDesignation(selectedteacherFeedback.Designation);
        setDepartment(selectedteacherFeedback.Department);
        setQuestion1(selectedteacherFeedback.question1);
        setQuestion2(selectedteacherFeedback.question2);
        setQuestion3(selectedteacherFeedback.question3);
        setQuestion4(selectedteacherFeedback.question4);
        setQuestion5(selectedteacherFeedback.question5);
        setQuestion6(selectedteacherFeedback.question6);
        setQuestion7(selectedteacherFeedback.question7);
        setQuestion8(selectedteacherFeedback.question8);
        setQuestion9(selectedteacherFeedback.question9);
        setQuestion10(selectedteacherFeedback.question10);
        setSuggestion(selectedteacherFeedback.suggestion);
        setSelectedId(id);
    };
    return (
        <>
            <div>
                <div className='d-flex justify-content-between my-3'>
                    <h3>Teacher Feedbacks </h3>
                </div>
                <div className='table-responsive'>
                    <table className="table table-hover">
                        <thead className="table-primary">
                            <tr>
                                <th scope="col">S.no</th>
                                <th scope="col">Name</th>
                                <th scope="col">Email</th>
                                <th scope="col">Designation</th>
                                <th scope="col">Department</th>
                                <th scope="col">date</th>

                                <th scope="col">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {status === "loading" && (
                                <tr className='my-2'>
                                    <td colSpan={8}>
                                        <Skeleton count={10} height={90} />
                                    </td>
                                </tr>
                            )}
                            {status === "failed" && (
                                <tr>
                                    <td colSpan={8}>
                                        <p className='text-center fw-bold'>{"Data not found"}</p>
                                    </td>
                                </tr>
                            )}
                            {status === "succeeded" && teacherFeedbacks.data && teacherFeedbacks.data.map((teacherFeedback, index) => {
                                const newdate = new Date(teacherFeedback.createdAt);
                                const formattedDate = newdate.toLocaleDateString("default", {
                                    day: "2-digit",
                                    month: "long",
                                    year: "numeric"
                                });
                                return (
                                    <tr key={teacherFeedback._id}>
                                        <th scope="row">{index + 1}</th>
                                        <td>{teacherFeedback.name}</td>
                                        <td>{teacherFeedback.email}</td>
                                        <td>{teacherFeedback.Designation}</td>
                                        <td>{teacherFeedback.Department}</td>
                                        <td>{formattedDate}</td>
                                        <td className='cursor'>
                                            <div onClick={() => handlid(teacherFeedback._id)}><i className='bi bi-eye-fill text-primary fs-5' data-bs-toggle="modal" data-bs-target="#exampleModal"></i></div>
                                            <div onClick={() => handleDelete(teacherFeedback._id)}><i className='bi bi-trash text-danger fs-5'></i></div>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Modal  */}
            <div
                className="modal fade"
                id="exampleModal"
                tabIndex={-1}
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-xl modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">
                                teacher Feedback
                            </h1>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-12 col-lg-4 mb-3">
                                    <div>
                                        <h6>Name</h6>
                                        <h6 className='text-primary'>{name}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 mb-3">
                                    <div>
                                        <h6>Email</h6>
                                        <h6 className='text-primary'>{email}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 mb-3">
                                    <div>
                                        <h6>Designation</h6>
                                        <h6 className='text-primary'>{Designation}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-4 mb-3">
                                    <div>
                                        <h6>Department</h6>
                                        <h6 className='text-primary'>{Department}</h6>
                                    </div>
                                </div>

                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>1 .The Program and course Outcome are clearly stated.</h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question1}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>2. The curriculum provides the freedom for testing and assessment of students.
                                        </h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question2}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>3. The curriculum provides the freedom to adapt new techniques of teaching.

                                        </h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question3}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>4. The books prescribed as reference material are relevant, updated and appropriate.
                                        </h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question4}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>5. Demonstrations in the lab are related to the real life application.

                                        </h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question5}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>6. Assessment pattern is adequate to do formative and summative evaluation.
                                        </h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question6}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>7. The Curriculum has a good balance of theory and application.

                                        </h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question7}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>8. The curriculum helps in developing personality by inculcating soft skills, life skills and employability skills.

                                        </h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question8}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>9. Curriculum helps in updating knowledge and innovative thinking.

                                        </h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question9}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 mb-3">
                                    <div>
                                        <h6>10. The opinion of the faculty members is considered during curriculum revision.

                                        </h6>
                                        <h6 className='text-primary'><i className='bi bi-circle-fill text-primary' style={{ fontSize: "10px" }}></i> {question10}</h6>
                                    </div>
                                </div>
                                <div className="col-12 col-lg-12 my-3 border rounded py-2">
                                    <div>
                                        <h6>SUGGESTIONS</h6>
                                        <p>{suggestion}</p>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    data-bs-dismiss="modal"
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default TeacherFeedback;
